"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CATEGORIES = exports.MORE_OPTIONS_CATEGORIES = exports.IMPERSONATION_CATEGORIES = exports.THREAT_CATEGORIES = exports.HARRASSMENT_CATEGORIES = exports.NUDITY_CATEGORIES = exports.DELAY_AFTER_SUBMIT = exports.REPORT_SUBMITTED_CLOSE_MESSAGE = exports.REPORT_SUBMITTED_MESSAGE = exports.REPORT_SUBMITTED_HEADER = exports.CLOSE_BUTTON = exports.CANCEL_BUTTON = exports.SUBMIT_BUTTON = exports.TEXTFIELD_TITLE = exports.REPORT_SUBTEXT = exports.REPORT_SNAP = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const report_reason_1 = require("@snapchat/ts-protos/abuse/support/report_reason");
const react_intl_1 = require("react-intl");
const ReportModalContent_1 = require("./ReportModalContent");
const COPYRIGHT_REPORTING_LINK = "https://help.snapchat.com/hc/requests/new?co=true&ticket_form_id=71659";
exports.REPORT_SNAP = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "8Sw4jY", description: "Title of modal for reporting a snap", defaultMessage: "Report Snap" }));
exports.REPORT_SUBTEXT = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "sRM8i5", description: "Subtitle asking users for report category", defaultMessage: "Why do you want to report this Snap?" }));
exports.TEXTFIELD_TITLE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "jqpH+5", description: "Title above textbox where more information about snap to be reported can be written", defaultMessage: "Is there any more information you want to share about this Snap?" }));
exports.SUBMIT_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "ESomE8", description: "Submit report", defaultMessage: "Submit" }));
exports.CANCEL_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "PyzdXL", description: "Cancel reporting snap", defaultMessage: "Cancel" }));
exports.CLOSE_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "2LLiYb", description: "Close reporting snap", defaultMessage: "Close" }));
exports.REPORT_SUBMITTED_HEADER = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "VRmDFV", description: "Header shown after a report has been submitted", defaultMessage: "Snap Reported" }));
exports.REPORT_SUBMITTED_MESSAGE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "ATeDiR", description: "Copy shown afer a report has been submitted", defaultMessage: "Thank you for reporting this Snap." }));
exports.REPORT_SUBMITTED_CLOSE_MESSAGE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "04qzmG", description: "Message relaying close prompt after report has been submitted", defaultMessage: "You will now be taken to the next Snap - press 'Close' to do this right away or we will continue automatically in 10 seconds." }));
exports.DELAY_AFTER_SUBMIT = 10000;
// This is an example of a sub category that opens from a top level category
exports.NUDITY_CATEGORIES = new Map([
    [
        report_reason_1.ReportReason.INAPPROPRIATE_FIRST_PERSON,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "rNVPnk", description: "Report category for a snap with inappropriate content of the user", defaultMessage: "It's an inappropriate Snap of me" })),
        },
    ],
    [
        report_reason_1.ReportReason.INAPPROPRIATE_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Gvuqme", description: "Report category for a snap with inappropriate content of somebody else", defaultMessage: "It's an inappropriate Snap of someone else" })),
        },
    ],
    [
        report_reason_1.ReportReason.INAPPROPRIATE_PROMOTION,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "1PzCdm", description: "Report category for a snap which is threatening to post inappropriate snaps", defaultMessage: "It asks for or threatens to post inappropriate Snaps" })),
        },
    ],
    [
        report_reason_1.ReportReason.INAPPROPRIATE_CHILD,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "BLbe57", description: "Report category for child sexual exploitation", defaultMessage: "It involves a child" })),
        },
    ],
]);
// This is an example of a sub category that opens from a top level category
exports.HARRASSMENT_CATEGORIES = new Map([
    [
        report_reason_1.ReportReason.BULLYING_HARASSMENT_FIRST_PERSON,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "vTd+a8", description: "Report category for a snap which is bullying or harassing the user", defaultMessage: "I'm being bullied or harassed" })),
        },
    ],
    [
        report_reason_1.ReportReason.BULLYING_HARASSMENT_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "FDOu63", description: "Report category for a snap which is bullying or harassing something else", defaultMessage: "Someone else is being bullied or harassed" })),
        },
    ],
    [
        report_reason_1.ReportReason.PRIVACY_INVASION_FIRST_PERSON,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "AbkQPs", description: "Report category for a snap which is an invasion of privacy", defaultMessage: "It's an invasion of privacy" })),
        },
    ],
    [
        report_reason_1.ReportReason.HATE_SPEECH_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "lbui+i", description: "Report category for a snap which includes hate speech", defaultMessage: "It's hate speech targeting me or another group" })),
        },
    ],
]);
exports.THREAT_CATEGORIES = new Map([
    [
        report_reason_1.ReportReason.THREAT_THREATENING_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Ftta6c", description: "Report category for a snap which is threatening a person or place", defaultMessage: "It's threatening a person or place" })),
        },
    ],
    [
        report_reason_1.ReportReason.VIOLENT_DISTURBING_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "N7Wq/c", description: "Report category for a snap which is violent or disturbing", defaultMessage: "Violent or disturbing" })),
        },
    ],
]);
exports.IMPERSONATION_CATEGORIES = new Map([
    [
        report_reason_1.ReportReason.IMPERSONATION_FIRST_PERSON,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "WyUwHm", description: "Report category for a snap where the snapchatter is pretending to be the user", defaultMessage: "They are pretending to be me" })),
        },
    ],
    [
        report_reason_1.ReportReason.IMPERSONATION_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { description: "Report category for a snap where the snapchatter is pretending to be others", defaultMessage: "They are pretending to be someone else" })),
        },
    ],
]);
exports.MORE_OPTIONS_CATEGORIES = new Map([
    [
        report_reason_1.ReportReason.SELF_HARM_SUICIDE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "5m3Hu8", description: "Report category for a snap which makes the user worried the snapchatter may hurt themselves", defaultMessage: "I'm worried this Snapchatter might hurt themselves" })),
        },
    ],
    [
        report_reason_1.ReportReason.DRUG_SALE_USE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "L2hojs", description: "Report category for a snap which attempts to buy or sell drugs", defaultMessage: "It's attempting to buy or sell drugs" })),
        },
    ],
    [
        report_reason_1.ReportReason.WEAPON_SALE_USE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "cT5GPH", description: "Report category for a snap which attempts to buy or sell weapons", defaultMessage: "It's attempting to buy or sell weapons" })),
        },
    ],
    [
        report_reason_1.ReportReason.SPAM_GENERAL,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "GJZs5E", description: "Report category for a snap which is spam", defaultMessage: "It's spam" })),
        },
    ],
]);
/*
 * This config lays out the top level reporting categories
 * To add a new category to report,
 * - create a ReportReason
 * - add it to the default categories here
 * - if you want to make a category open a set of sub categories, create a new map of
 *   report category and add it to 'subCategory'
 */
exports.DEFAULT_CATEGORIES = new Map([
    [
        { reason: report_reason_1.ReportReason.DONT_LIKE_WANT_TO_SEE },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "5HsSrO", description: "Report category for a snap which the user doesn't like", defaultMessage: "I just don't like it" })),
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.NUDITY },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "CAgCZ5", description: "Report category for a snap which contains nudity or sexual content", defaultMessage: "Nudity or sexual content" })),
            subCategory: exports.NUDITY_CATEGORIES,
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.HARASSMENT },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "RJo0Z3", description: "Report category for a snap which contains harassment or hate speech", defaultMessage: "Harassment or Hate speech" })),
            subCategory: exports.HARRASSMENT_CATEGORIES, // Make a category open a set of sub categories
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.THREAT },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "0dJz6S", description: "Report category for a snap which contains threats or violence", defaultMessage: "Threatening, violent, or concerning" })),
            subCategory: exports.THREAT_CATEGORIES,
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.IMPERSONATION },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "oPQk4V", description: "Report category for a snap where the snapchatter is pretending to be others", defaultMessage: "They are pretending to be someone else" })),
            subCategory: exports.IMPERSONATION_CATEGORIES,
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.COPYRIGHT },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "+lhElX", description: "Report category for a snap containing copyright infringement", defaultMessage: "Copyright infringement" })),
            reportLink: COPYRIGHT_REPORTING_LINK,
        },
    ],
    [
        { category: ReportModalContent_1.NonSubmittableCategory.MORE_OPTIONS },
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "2V40yT", description: "More report categories", defaultMessage: "More Options" })),
            subCategory: exports.MORE_OPTIONS_CATEGORIES,
        },
    ],
]);
//# sourceMappingURL=constants.js.map